"use strict";

import "./shared/nucont.shared.module";
import "@nuconthackers/storybook-design-system";
import angular from "angular";
import "angular-animate";
import "angular-aria";
import "angular-input-masks";
import "angular-locale-pt-br";
import "angular-material";
import "angular-material/angular-material.min.css";
import "angular-messages";
import "angular-sanitize";
import uiRouter from "angular-ui-router";
import ngFileUpload from "ng-file-upload";
import "oclazyload";
import "simplebar";
import "simplebar/dist/simplebar.css";

angular.module("nucont", [
    uiRouter,
    "ngAnimate",
    "ngAria",
    "ngMaterial",
    "ngMessages",
    "ngSanitize",
    "ngLocale",
    "ui.utils.masks",
    ngFileUpload,
    "oc.lazyLoad",
    "DSNApp",
    "nucont.shared"
]);
